














import { Vue, Component } from 'vue-property-decorator';

const cssPrefix = 'sw-ftr-security-news';

@Component({
})
export default class SwFtrSecurityNews extends Vue {
  cssPrefix = cssPrefix;
}
